import styled from "styled-components";

import { Box, Heading, Link, Stack } from "@vinomofo/components";
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TwitterIcon,
  YoutubeIcon,
} from "@vinomofo/icons";

import { useMarket } from "../../../hooks/use-market";
import { SocialPlatform, socialColors, urlForHandle } from "./helpers";

const SocialIconLink = styled(Link)<{ fill: string }>`
  svg {
    fill: ${({ fill }) => fill};
    height: 30px;
    width: 30px;
  }
`;

const socialIcons = {
  facebook: <FacebookIcon />,
  twitter: <TwitterIcon />,
  linkedin: <LinkedInIcon />,
  instagram: <InstagramIcon />,
  youtube: <YoutubeIcon />,
};

type SocialLink = {
  url: string;
  iconColor: string;
  icon: JSX.Element;
};

export const SocialLinks = (): JSX.Element => {
  const {
    currentMarket: { socialHandles },
  } = useMarket();

  const socialLinks: Array<SocialLink> = Object.keys(socialHandles).reduce(
    (acc, key) => {
      if (!socialHandles[key]) return acc;
      const handle = socialHandles[key];

      acc.push({
        url: urlForHandle(key as SocialPlatform, handle),
        iconColor: socialColors[key],
        icon: socialIcons[key],
      });
      return acc;
    },
    []
  );

  return (
    <Box width="100%" display="flex" justifyContent="center">
      <Box
        display="grid"
        gridGap={[5, 20]}
        gridTemplateColumns={`repeat(${socialLinks.length}, 1fr)`}
      >
        {socialLinks.map((socialLink: SocialLink, i) => {
          return (
            <SocialIconLink
              key={i}
              fill={socialLink.iconColor}
              href={socialLink.url}
              textAlign="center"
            >
              {socialLink.icon}
            </SocialIconLink>
          );
        })}
      </Box>
    </Box>
  );
};
